import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericEntityList from '../../components/Common/GenericEntityList';

const ExchangeManagement: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateExchange = () => {
    navigate('/exchanges/create');
  };

  return (
    <GenericEntityList
      entityType="exchange"
      detailsRoute="/exchanges"
      onCreateClick={handleCreateExchange}
      createButtonLabel="Add Exchange"
      showCreateButton={true}
      showExportButton={true}
    />
  );
};

export default ExchangeManagement;

